import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as JSZip from 'jszip';
import { cloneDeep } from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TabsComponent } from 'src/app/footer/tabs/tabs.component';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { ConfigurationLayerModel, ConfigurationModel } from 'src/app/models/configuration';
import { Project, ProjectUploadModel } from 'src/app/models/project';
import { UserSettings } from 'src/app/models/UserSettings';
import { AddProjectControlService } from 'src/app/services/add-project-control.service';
import { AreaService } from 'src/app/services/area.service';
import { CalculationsService } from 'src/app/services/calculations.service';
import { ConfigurationColorService } from 'src/app/services/configuration-color-service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CoordinatePointsFilterService } from 'src/app/services/coordinate-points-filter.service';
import { CoordinatePointsService } from 'src/app/services/coordinate-points.service';
import { CreateProjectService } from 'src/app/services/create-project.service';
import { MapService } from 'src/app/services/map.service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { NavaidsFilterService } from 'src/app/services/navaids-filter.service';
import { PointsService } from 'src/app/services/points.service';
import { ProjectService } from 'src/app/services/project.service';
import { RouteSegmentsService } from 'src/app/services/route-segments.service';
import { TabsService } from 'src/app/services/tabsService';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { UserSettingsService } from 'src/app/services/userSettings.service';
import * as fileSaver from 'file-saver';
import * as moment from 'moment';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { CalculationModel } from 'src/app/models/calculations';
import { Tab } from 'src/app/models/Tab';
import { ProgressService } from 'src/app/services/progress.service';
import { firstValueFrom } from 'rxjs';
import { FeatureType } from "../../../models/EnumTypes";
import { UtilsService } from 'src/app/services/utils.service';
import { SaamTrafficService } from 'src/app/services/saamtrafficservice';
import { ImportFormat } from 'src/app/models/importFormat';

import {GritProjectService} from "../../../services/grit/grit.project.service";
import {GritApiService} from "../../../services/grit/grit.api.service";
import {GritUserRoleGroup, GritUserService} from "../../../services/grit/grit.user.service";

@Component({
  selector: 'app-project-management-control',
  templateUrl: './project-management-control.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class ProjectManagementControlComponent implements OnInit {
  @ViewChild('upload') fileInput: ElementRef;

  projectController: ProjectService;

  active: boolean = false;

  readonly importFormat: ImportFormat = ImportFormat.ZIP_FORMAT;

  constructor(private modalService: ModalControlService,
    public bsModalRef: BsModalRef,
    public projController: ProjectService,
    private projectDetailController: AddProjectControlService,
    private modelConfirmationMessage: ModalConfirmationService,
    private createProjectModal: CreateProjectService,
    private pointsController: PointsService,
    private errorModal: ModalControlService,
    private areaService: AreaService,
    private toolsService: ToolsControlService,
    private menuService: MenuManagementService,
    private routeSegmentService: RouteSegmentsService,
    private calculationService: CalculationsService,
    private tabsService: TabsService,
    private userSettingsService: UserSettingsService,
    private configurationColorService: ConfigurationColorService,
    private pointsService: PointsService,
    private configurationService: ConfigurationService,
    private mapService: MapService,
    public coordinatePointsService: CoordinatePointsService,
    private coordinatePointsFilterService: CoordinatePointsFilterService,
    private navaidsFilterService: NavaidsFilterService,
    private http: HttpClient,
    private uiBlock: UiBlockService,
    private endpointsService: EndpointsService,
    private progressService: ProgressService,
    private saamtrafficServiece: SaamTrafficService,

    //#region GRIT
    private gritProjectService: GritProjectService,
    private gritApiService: GritApiService,
    protected gritUserService: GritUserService,
    //endregion
  ) {
    this.projectController = projController;
    //this.projectController.activeProject = new Project();
  }

  ngOnInit(): void {
    //this.projectController.getAllProjects();
  }

  cancelProjectManagement(): void {
    //this.configurationController.cancelConfigurationPopup();
    this.bsModalRef.hide();
  }

  projectsTrigger(): void {
    this.active = !this.active;
  }

  deleteProjectTrigger(): void {
    if (this.projectController.selectedProject.id == this.projectController.activeProject.id) {
      this.errorModal.showMesssageModal("Warning", "The active project cannot be deleted.");
    } else if (this.projectController.selectedProject && this.projController.projectEditable(this.projController.selectedProject)) {
      this.modelConfirmationMessage.showMesssageConfirmationModal("Delete Project", "Do you want to delete the project with the name '" + this.projectController.selectedProject.name + "'?", 'Yes', 'No', this.boundedDeleteSelectedProject);
    }
  }

  RemoveProjectFromObjectArray(id: number): void {
    this.projectController.projects.forEach((value, index) => {
      if (value.id == id) this.projectController.projects.splice(index, 1);
    });
  }

  boundedDeleteSelectedProject = this.deleteSelectedProject.bind(this);

  async deleteSelectedProject(): Promise<void> {
    this.uiBlock.startBlock("Deleting project...")

    let projectId = this.projectController.selectedProject.id;

    //#region GRIT
    await firstValueFrom(this.projectController.deleteProjectCalculations(this.projectController.selectedProject.id));
    this.gritApiService.interferenceTestDelete(projectId).then(
      (response) => {
        this.projController.deleteProject(projectId).subscribe({
          next: (data) => {
            if (data){
              const selectedProjectId: number = this.projectController.selectedProject.id;
              this.RemoveProjectFromObjectArray(selectedProjectId);

              this.projectController.selectedProject = undefined;
              this.uiBlock.stopBlock();
              this.modalService.showMesssageModal(
                'Delete',
                'The Project was deleted successfully.'
              );
              if (this.progressService.progressMap != null && this.progressService.progressMap.size > 0){
                for (const [key, value] of this.progressService.progressMap.entries()) {
                  if (value.projectId != null && value.projectId == selectedProjectId) {
                    this.progressService.progressMap.delete(key);
                  }
                }
              }
            }
            else {
              this.errorModal.showMesssageModal("Error","Error deleting project.");
              this.uiBlock.stopBlock();
            }

          },
          error: (error) => {
            this.uiBlock.stopBlock();
            if (error && error.status == 401) {
              this.modalService.showMesssageModal(
                'Error Deleting',
                'You can not delete the Default Project.'
              )
              return;
            }
            this.errorModal.showMesssageModal("Error","Error deleting project.");
          }
        });
      },

      (error)=> {
        this.uiBlock.stopBlock();
        if (error && error.status == 401) {
          this.modalService.showMesssageModal(
            'Error Deleting',
            'You can not delete the Default Project.'
          )
          return;
        }
        this.errorModal.showMesssageModal("Error","Error deleting project. Interference Test might no longer be in draft state.");
      }
    );
    //endregion
  }

  addProjectTrigger(): void {
    //Create project default values
    let emptyProject: Project = new Project();
    emptyProject.name = "New Project";
    emptyProject.description = "Description";
    emptyProject.configurationID = 1;
    this.projectController.importMode = false;
    this.createProjectModal.showModal(emptyProject, false, this.projectController.projects);
  }

  editProjectTrigger(): void {
    if (this.projectController.selectedProject && this.projController.projectEditable(this.projController.selectedProject)) {
      // default value, just to pass the edit form validation.
      this.projectController.selectedProject.configurationID = 1;
      this.createProjectModal.showModal(this.projectController.selectedProject, true, this.projectController.projects);
      this.userSettingsService.userSettings.visibleStaticLayerIDs.forEach((results) => {

      })
    }
  }

  activateProject(project : Project){
    if (project.active) return;

    const extent = this.mapService.getCurrentExtent();

    this.pointsService.clearSelectedFeatures();
    // hide static layers
    this.userSettingsService.userSettings.visibleStaticLayerIDs
      .forEach((layerID) => {
        let staticLayer = this.configurationService.currentConfiguration.layers
          .find((layer) => layer.id == layerID);
        if (staticLayer) {
          staticLayer.visible = true;
          this.mapService.activateLayer(staticLayer);
        }
      })
    this.projController.activateProject(project).subscribe(
      async (projectFromEndpoint: Project) => {
        if (projectFromEndpoint) {
          try {
            await this.calculationService.deleteCalculationsCache();
            this.tabsService.tabs = this.tabsService.tabs.filter((tab: Tab) => tab.type == TabsService.PERFORMANCE_ANALYSIS);
            this.tabsService.tabs.forEach((tab: Tab) => tab.visible = false);
            this.tabsService.updateTabs();
            this.tabsService.closeTabs();
            this.projectController.activeProject.active = false;
            let newActiveProject = this.projectController.projects.find((proj: Project) => proj.id == project.id);
            newActiveProject.active = true;
            this.projectController.activeProject = newActiveProject;
            this.userSettingsService.userSettings = JSON.parse(projectFromEndpoint.userSettingsJSON);
            this.projectController.activeProject.userSettingsJSON = projectFromEndpoint.userSettingsJSON;

            this.userSettingsService.updateUserSettingsFields(JSON.parse(this.projectController.activeProject.userSettingsJSON));

            const calculationLayer = this.calculationService.getCalculationsLayer();
            for (let i = 0; i < calculationLayer.childLayers.length; i++) {
              this.calculationService.getCalculationsLayer().deleteLayer(calculationLayer.childLayers[i]);
              i--;
            }
            this.pointsService.initializeVisibilities(this.userSettingsService.userSettings);
            this.configurationService.getAllConfigurations(this.projectController.activeProject.id).subscribe((data) => {
              this.configurationService.selectedRow = -1;
              this.configurationService.configurationList = [];
              for (const element of data) {
                this.configurationService.configurationList.push(new ConfigurationModel(element));
                if (element.active) {
                  this.uiBlock.startBlock("Adding entities to map...");
                  this.configurationService.getConfiguration(element.id).subscribe((config) => {
                    this.uiBlock.stopBlock();

                    this.configurationService.currentConfiguration = ConfigurationModel.map(config);
                    this.userSettingsService.userSettings.visibleStaticLayerIDs
                      .forEach((layerID) => {
                        let staticLayer = this.configurationService.currentConfiguration.layers
                          .find((layer) => layer.id == layerID);

                        if (staticLayer) {
                          this.mapService.activateLayer(staticLayer);
                        }
                      })
                    
                    for (const staticLayer of this.configurationService.currentConfiguration.layers) {
                      if (staticLayer.type != 'GeoJsonLayer' || this.userSettingsService.userSettings.visibleStaticLayerIDs.includes(staticLayer.id))
                        continue;
                      this.mapService.populateGeoJsonLayer(staticLayer);
                    }

                    this.configurationService.updateCoordenateControlRCSList();
                    this.mapService.reprojectMap(this.configurationService.coordenateService.activeRCS.epsg);
                    this.calculationService.initializeCalculationService(JSON.parse(this.configurationService.currentConfiguration.cumulativeColorSettingsJson));
                    this.progressService.initializeProgressService(); // CHANGE: currently, this is where previous calculations are added to map
                    this.configurationColorService.initialize();
                    this.navaidsFilterService.filters = cloneDeep(this.userSettingsService.userSettings.navaidFilters);
                    this.coordinatePointsFilterService.filters = cloneDeep(this.userSettingsService.userSettings.coordinatePointFilters);
                    this.pointsController.deleteNavaidsFromMap();
                    this.pointsController.deleteCoordinatePointsFromMap();
                    this.pointsController.deleteAnnotationsFromMap();
                    this.pointsController.deleteProceduresFromMap();
                    this.pointsController.deleteFlightInspectionsFromMap();
                    this.pointsController.deleteProcessingToolsFromMap();
                    this.pointsController.deleteUserLayers();
                    this.pointsController.deleteTrajectoriesFromMap();
                    this.pointsController.deleteAirSpaceBoundariesFromMap();
                    this.saamtrafficServiece.deleteSAAMLayersFromMap();
                    const isSwitchProject: boolean = true;

                    this.areaService.fetchAllAreasAndSetDefault(true, () => {

                      this.saamtrafficServiece.fetchAndAddSaamTrafficLayers(isSwitchProject);
                      this.pointsController.fetchAndAddPartialNavaids(extent, isSwitchProject);
                      this.pointsController.fetchAndAddPartialCoordinatePoints(extent, isSwitchProject);
                      this.pointsController.fetchAllAnnotations(isSwitchProject);
                      this.pointsController.fetchAndAddPartialProcedures(extent, isSwitchProject);
                      this.pointsController.fetchAndAddPartialAirSpaceBoundaries(extent, isSwitchProject);
                      this.pointsController.fetchAndAddPartialTrajectories(extent, isSwitchProject);
                      this.pointsController.fetchAndAddFlightInspection(isSwitchProject);
                      this.pointsController.fetchAndAddProcessingTool(isSwitchProject);
                      this.pointsController.fetchAndAddUserLayersToMap(isSwitchProject);
                    });

                    this.routeSegmentService.loadState(project.id, isSwitchProject);

                    //#region GRIT
                    this.gritProjectService.switchProject(project);
                    //endregion

                  },
                    (error) => {
                      this.errorModal.showMesssageModal("Error", "Error activating project.");
                      this.uiBlock.blockUI.reset();
                      console.log(error);
                    })
                }
              }
            });

          } catch (e) {
            this.errorModal.showMesssageModal("Error", "Error activating project.");
            this.uiBlock.blockUI.reset();
          }
        } else {
          this.errorModal.showMesssageModal("Error", "Error activating project.");
        }

      },
      (error) => {
        this.errorModal.showMesssageModal("Error", "Error activating project.");
      }
    );

  }

  importProjectTrigger(event: any): void {
    //Create project default values
    let emptyProject: ProjectUploadModel = new ProjectUploadModel();
    emptyProject.name = "Import Project";
    emptyProject.description = "Description";
    emptyProject.zipFile = <File>event.target.files[0];
    this.projectController.importMode = true;
    this.createProjectModal.showImportModal(emptyProject, this.projectController.projects);
    this.fileInput.nativeElement.value = '';
  }

  async deleteCache() {
    await firstValueFrom(this.http.delete(
      this.endpointsService.endpointDeleteEntitiesCache,
      this.endpointsService.httpOptions
    ))
  }


  async exportProject() {
    this.uiBlock.startBlock(`Exporting selected project:${this.projectController.selectedProject.name}...`);
    try {
      const zip: JSZip = new JSZip();
      let filename: string;
      let file: Blob;
      await this.deleteCache();
      await this.calculationService.deleteCalculationsCache();
      await this.configurationService.fetchTerrainsByProjectPromiseRequest(this.projectController.selectedProject.id);
      if (!this.configurationService.terrainTypes || this.configurationService.terrainTypes.length == 0) {
        await this.configurationService.fetchTerrainTypesPromiseRequest();
      }

      const fileSuffix: string = moment(new Date()).format("YYYY-MM-DD-HHmmss");

      file = new Blob([this.projectController.selectedProject.name], {
        type: 'text/plain'
      });

      filename = "ExportedProjectName_" + fileSuffix + ".txt";
      zip.file(filename, file);

      file = await this.pointsController.exportNavaidsXMLFileHttpRequest(null, false, this.projectController.selectedProject.id).toPromise(); //TODO: include navaid files?
      if (file != null) {
        filename = "ExportedNavaids_" + fileSuffix + ".xml";
        zip.file(filename, file);
      }

      file = await this.pointsController.exportCPXMLFileHttpRequest(null, this.projectController.selectedProject.id).toPromise();
      if (file != null) {
        filename = "ExportedCP_" + fileSuffix + ".xml";
        zip.file(filename, file);
      }

      file = (await this.pointsController.exportProceduresXMLFileHttpRequest(null, this.projectController.selectedProject.id).toPromise());
      if (file != null) {
        filename = "ExportedProcedures_" + fileSuffix + ".xml";
        zip.file(filename, file);
      }

      file = await this.pointsController.exportAirSpaceBoundariesXMLFileHttpRequest(null, this.projectController.selectedProject.id).toPromise();
      if (file != null) {
        filename = "ExportedAirSpaceBoundaries_" + fileSuffix + ".xml";
        zip.file(filename, file);
      }

      const configurations: ConfigurationModel[] = await this.configurationService.getAllConfigurations(this.projectController.selectedProject.id).toPromise();
      // only one config per proj
      file = await this.configurationService.exportConfigurationXMLFileHttpRequest(configurations[0].id).toPromise();
      if (file != null) {
        filename = "ExportedConfig_" + fileSuffix + ".xml";
        zip.file(filename, file);
      }

      file = await this.pointsController.exportAreasXMLFileHttpRequest().toPromise();
      if (file != null) {
        filename = "ExportedAreas_" + fileSuffix + ".xml";
        zip.file(filename, file);
      }
      file = await this.pointsController.exportAnnotationsXMLFileHttpRequest().toPromise();
      if (file != null) {
        filename = "ExportedAnnotations_" + fileSuffix + ".xml";
        zip.file(filename, file);
      }
      file = await this.pointsController.exportTrajectoryXMLFileHttpRequest().toPromise();
      if (file != null) {
        filename = "ExportedTrajectories_" + fileSuffix + ".xml";
        zip.file(filename, file);
      }
      const calculations: CalculationModel[] = await this.calculationService.getPreviousCalculationsHttpRequest(this.projectController.selectedProject.id, true).toPromise();
      if (calculations && calculations.length > 0) {
        for (const calculation of calculations) {
          calculation.calcInfo = await this.calculationService.getCalcInfo(calculation.id);
        }
        const calculationsJSON: string = JSON.stringify(calculations);
        filename = "ExportedCalculations_" + fileSuffix + ".json";
        zip.file(filename, calculationsJSON);
      }

      if (this.configurationService.savedTerrains$ != null && this.configurationService.savedTerrains$.getValue().length != 0) {
        const terrainListFileContent: string = JSON.stringify({ terrains: this.configurationService.savedTerrains$.getValue() });
        filename = "ExportedTerrains_" + fileSuffix + ".json";
        zip.file(filename, terrainListFileContent);
      }

      zip.generateAsync({ type: 'blob', compression: "DEFLATE" }).then(function (content) {
        filename = "ExportedProject_" + fileSuffix + ".zip";
        fileSaver.saveAs(content, filename);
      });
    } catch (e) {
      this.errorModal.showMesssageModal("Error", "Error exporting project.");
    } finally {
      this.uiBlock.stopBlock();
    }
  }

  protected readonly GritUserRoleGroup = GritUserRoleGroup;
}
